import classNames from "classnames";
import type { ButtonHTMLAttributes } from "react";
import { forwardRef } from "react";
import IconLoading from "~/assets/icon/loading.svg";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  size?: "normal" | "small";
  variant?:
    | "primary"
    | "secondary"
    | "link"
    | "ghost"
    | "outline"
    | "inline"
    | "base"
    | "danger"
    | "danger-outline"
    | null;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function ButtonInner(
    { loading, children, variant = "primary", size = "normal", ...props },
    ref
  ) {
    return (
      <button
        {...props}
        ref={ref}
        className={classNames(
          "flex items-center justify-center px-4 text-center font-semibold leading-normal transition-all",
          "select-none disabled:pointer-events-none disabled:!bg-gray-200 disabled:!text-gray-400",
          loading && "pointer-events-none cursor-default",
          size === "normal" ? "h-12 rounded-xl" : "h-[38px] rounded-lg text-sm",
          variant === "base" &&
            "border-1 border-gray-300 bg-white !font-medium shadow-xs",
          variant === "primary" &&
            "bg-primary-500 text-white hover:bg-primary-700",
          variant === "link" && "bg-transparent",
          variant === "outline" &&
            "inline-block border-1 border-gray-300 bg-white py-2 shadow-xs",
          variant === "ghost" &&
            "border-1 border-gray-300 bg-transparent text-primary-500",
          variant === "inline" && "bg-transparent text-primary-500",
          variant === "secondary" &&
            "border-1 border-primary-500 bg-transparent text-primary-500 hover:bg-primary-50",
          variant === "danger-outline" &&
            "border-1 border-red-500 bg-white text-red-500 hover:bg-red-50",
          variant === "danger" && "bg-red-500 text-white hover:bg-red-600",
          props.className
        )}
      >
        {loading ? (
          <img
            alt=""
            src={IconLoading}
            key="btn-loading-icon"
            className="inline-block h-6 w-6 animate-spin"
          />
        ) : (
          children
        )}
      </button>
    );
  }
);
